import Modale from './Modale'
import { ModaleStyled, ModaleMessageStyled } from './styles'

export default Modale
export { ModaleStyled, ModaleMessageStyled }
